import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import DropImage from './DropImage'
import { useCompanies } from '../hooks/useCompanies'
import { alertActions } from '../redux/AlertController'
import '../styles/modal.scss'

export const AddCompanyModal = ({ isOpen, onClose, onCreated }) => {
  const dispatch = useDispatch()
  const { createCompany } = useCompanies()

  const [name, setName] = useState('')
  const [logoBase64, setLogoBase64] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  if (!isOpen) return null

  const resetState = () => {
    setName('')
    setLogoBase64([])
    setError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!name.trim()) {
      setError('اسم الشركة مطلوب')
      return
    }

    setIsLoading(true)
    setError('')

    try {
      const payload = { name: name.trim() }
      if (logoBase64.length > 0) {
        payload.logoBase64 = logoBase64[0]
      }

      const created = await createCompany(payload)
      dispatch(alertActions.showAlert({ msg: 'تم إضافة الشركة بنجاح', type: 'success' }))
      onCreated?.(created)
      resetState()
      onClose()
    } catch (err) {
      const message = err?.message || 'حدث خطأ أثناء إضافة الشركة'
      setError(message)
      dispatch(alertActions.showAlert({ msg: message, type: 'error' }))
    } finally {
      setIsLoading(false)
    }
  }

  const handleClose = () => {
    resetState()
    onClose()
  }

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h2 className="TXT-heading2 color-normal">إضافة شركة جديدة</h2>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="companyName">اسم الشركة</label>
            <input
              id="companyName"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="أدخل اسم الشركة"
              required
            />
          </div>

          <div className="input-group">
            <label>شعار الشركة (اختياري)</label>
            <DropImage setAcceptedFile={setLogoBase64} maxFiles={1}>
              <div className="dropzone">
                <p>اسحب الشعار هنا أو اضغط للتحميل</p>
                {logoBase64.length > 0 && <span className="preview-hint">تم اختيار الشعار</span>}
              </div>
            </DropImage>
          </div>

          {error && <span className="error-message">{error}</span>}

          <div className="modal-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={handleClose}
              disabled={isLoading}
            >
              إلغاء
            </button>
            <button
              type="submit"
              className="submit-btn"
              disabled={isLoading}
            >
              {isLoading ? 'جاري الإضافة...' : 'إضافة الشركة'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AddCompanyModal